import axiosClient from "../../../../../../system/helpers/axiosConfig";

export const getCountriesList = (api) => {
  return axiosClient.get(api).then((r) => r.data);
};
